import React from 'react';
import {Box} from '@mui/material';
import {useNavigate} from 'react-router-dom';

type AppLogoProps = {
  color?: string;
};

/**
 * Nation Wholesale wordmark — "NATION" (dark teal) + "WHOLESALE" (amber)
 * rendered in Barlow Condensed (loaded in public/index.html), matching the
 * client-facing website's nav logo.
 */
const AppLogo: React.FC<AppLogoProps> = () => {
  const navigate = useNavigate();

  return (
    <Box
      className='app-logo'
      onClick={() => navigate('/Home')}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
      }}
    >
      <Box
        component='span'
        sx={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 800,
          fontSize: {xs: 22, sm: 26},
          lineHeight: 1,
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}
      >
        <Box component='span' sx={{color: '#073B3F'}}>
          NATION
        </Box>
        <Box component='span' sx={{color: '#F59E0B', ml: '0.4ch'}}>
          WHOLESALE
        </Box>
      </Box>
    </Box>
  );
};

export default AppLogo;
